import PageWrapper from "../../../src/containers/PageWrapper";
import regionCities from "../../../src/data/regionCities";
import { getRoleFromUrl } from "../../../src/data/getRole";
import PageHead from "../../../src/components/PageHead";
import { useRouter } from "next/router";
import {
  getCorrectUrlType,
  isProfessionalTypeInUrlCorrect,
  redirect,
} from "../../../src/utils/urlHelpers";
import { URL_COMPONENTS } from "../../../src/__constants__";
import { CityRegionListItem } from "../../../src/containers/RegionListPage";
import HowVFWorks from "../../../src/components/HowVFWorks";
import {getRegionPageMetaCanonical} from "../../../src/data/metaTagsHelper";
import { get, replace, snakeCase, split, startCase } from "lodash";

const RegionPage = () => {
  const router = useRouter();

  const regionInformation = split(router.asPath, "/");
  const inputRegion = decodeURIComponent(regionInformation[2]);
  const region = snakeCase(inputRegion);
  const regionWithHyphen = replace(inputRegion, "_", "-");
  const displayRegion = startCase(replace(inputRegion, "-", " "));
  const urlRole = getCorrectUrlType(regionInformation[1]);
  const role = getRoleFromUrl(urlRole);
  const places = get(regionCities, [region, "places"], []);
  const personType = getCorrectUrlType(router.query?.type);

  const renderCity = (city, role, index) => {
    const url = `/${role}/${city.toLowerCase()}`;

    return (
      <CityRegionListItem
        bulletPoint={`${index < 9 ? "0" + (index + 1) : index + 1}`}
        key={`city:${city}`}
        name={city}
        url={url}
      />
    );
  };

  return (
    <PageWrapper containerStyle='!p-0 [&>main]:!p-0'>
      <PageHead canonical={getRegionPageMetaCanonical(regionInformation, regionWithHyphen)} />
      
      <div className='p-0 min-h-[400px] bg-pale-mint-green'>
        <div className='p-14'>
          <h1 className="text-4xl m-0 mb-5">
            {role} in {displayRegion}
          </h1>

          <h5 className="text-2xl m-0 mb-5">
            Cities in {displayRegion}
          </h5>

          <div className='inline-grid grid-rows-5 gap-6 grid-flow-col max-md:grid-rows-6 max-sm:grid-rows-10 max-xs:flex max-xs:flex-col'>
            {places.map((city, index) => renderCity(city, urlRole, index))}
          </div>
        </div>
      </div>

      <section>
        <HowVFWorks personType={personType} />
      </section>
    </PageWrapper>
  );
};

export async function getServerSideProps(props) {
  const { params } = props;

  if (!isProfessionalTypeInUrlCorrect(URL_COMPONENTS, params.type))
    return redirect();

  if (!Object.keys(regionCities).includes(params.location.replace(/-/g, "_")))
    return redirect();

  return { props: {} };
}

export default RegionPage;
